/**
 * `ResultsFilteredEmpty` — o corpo da lista quando o CORTE esconde tudo: a busca
 * devolveu hotéis, mas nenhum passa pelos filtros em cena. Não é o
 * `SearchEmptyState` (aquele é o desfecho de uma busca sem resultado, com
 * "buscar de novo"/"nova busca"): aqui a saída é desfazer o corte, e a lista
 * volta sem rede. Sem esta peça a coluna ficava em BRANCO sob "0 hotéis de 8"
 * (#3217 C4).
 *
 * Composição dos slots `Empty` do DS com o `Button`, sem figura: é um estado
 * transitório dentro da página, não um palco. O título é `role="status"`: o
 * corte é gesto da pessoa, então anuncia sem interromper. A ação só monta com
 * `onClear` — um host travado (`locked`) não oferece o que não pode fazer.
 */
import { Button } from '@voll-intelligence/ui-kit/ui/button';
import { Empty, EmptyContent, EmptyHeader, EmptyTitle } from '@voll-intelligence/ui-kit/ui/empty';

export interface ResultsFilteredEmptyCopy {
  /** "Nenhum hotel com esses filtros." */
  readonly title: string;
  /** "Limpar filtros" — zera o corte, não a busca. */
  readonly clearLabel: string;
}

export function ResultsFilteredEmpty({
  copy,
  onClear,
}: {
  readonly copy: ResultsFilteredEmptyCopy;
  readonly onClear?: () => void;
}) {
  return (
    <Empty className="py-10">
      <EmptyHeader className="max-w-md">
        <EmptyTitle role="status" className="text-base leading-6 font-semibold tracking-normal">
          {copy.title}
        </EmptyTitle>
      </EmptyHeader>
      {onClear ? (
        <EmptyContent>
          <Button variant="outline" size="lg" onClick={onClear}>
            {copy.clearLabel}
          </Button>
        </EmptyContent>
      ) : null}
    </Empty>
  );
}
